import React from "react";
import { useParams, useNavigate } from 'react-router-dom';
import "./About.css";

export default function About() {

  const navigate = useNavigate();
  return (
    <div>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

      <section className="about-section">
        <div className="about-container">

          {/* LEFT COLUMN */}
          <div className="about-left">

            <div className="about-photo">
              <img src="/images/profile.png" />
            </div>

            <div className="education-section">

              <div className="section-title">🎓 Education</div>

              <div className="education-item">
                <div className="year">2025 - 2026</div>
                <div className="experience-title">Université Paris-Saclay</div>
                <div className="experience-desc">M2 in Human-Computer Interaction</div>
              </div>

              <div className="education-item">
                <div className="year">2024 - 2025</div>
                <div className="experience-title">Institut Polytechnique de Paris</div>
                <div className="experience-desc">M1 in Interaction, Graphics and Design</div>
              </div>

              <div className="education-item">
                <div className="year">2019 - 2023</div>
                <div className="experience-title">Bilkent University</div>
                <div className="experience-desc">Bachelor's in Computer Engineering</div>
              </div>

              <div className="education-item">
                <div className="year">2022</div>
                <div className="experience-title">National University of Singapore</div>
                <div className="experience-desc">Exchange Semester (Computer Engineering)</div>
              </div>

            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="about-text">
            <h2 class="hello">Hello, I'm Ayda!</h2>

            <p>
              I'm a graduating Human–Computer Interaction (HCI) student at{" "}
              <a
                href="https://www.universite-paris-saclay.fr/"
                target="_blank"
                rel="noreferrer"
                className="inline-link"
              >
                Université Paris-Saclay
              </a>.
            </p>

            <p>
              Over the years, I've worked on diverse projects across UX design, game & level design,
              software development, and academic research. My projects often explore themes of emotion and play.
            </p>

            <p>
              After spending four years diving deep into code and technical projects in my bachelor’s, 
              I realized what excites me the most is designing meaningful interactive systems. Now I focus on user-centered design, UX research, 
              and interactive prototyping. My style of work has been shaped through my background in computer science and arts.
            </p>

            <p>
              Outside of work, I’m usually planning my next trip, reading thrillers with a cup of tea, or losing track of time while painting.
            </p>

            <p>
              Experiencing life in different cities is a big part of my story. Besides my home-town Ankara,
              I’ve lived in Singapore and Oslo. Now I’m happily based in Paris, chasing restaurants, art exhibitions, and inspiration.
            </p>

            <p>
              Thanks for reading until here. Feel free to write me an email or say hi on{" "}
              <a
                href="https://www.linkedin.com/in/aydayurtoglu/"
                target="_blank"
                rel="noreferrer"
                className="inline-link2"
              >
                LinkedIn
              </a>.
              I'm always open to collaborate on fun ideas!
            </p>
          </div>

        </div>
      </section>

      {/* SKILLS SECTION */}
      <div className="hero-divider">
        <div className="marquee">
          <span>UX Design ✦ UX Research ✦ Interaction Design ✦ UI Design ✦ Prototyping ✦ Usability Testing ✦ Human–Computer Interaction ✦ Product Thinking ✦ Design Systems ✦ Information Architecture ✦ Front-end Development ✦ React ✦ TypeScript ✦ Figma ✦ Unity ✦ Visual Design ✦ Adobe Suite ✦ Systematic Design ✦ Storyboarding ✦ Wireframing ✦</span>
          <span>UX Design ✦ UX Research ✦ Interaction Design ✦ UI Design ✦ Prototyping ✦ Usability Testing ✦ Human–Computer Interaction ✦ Product Thinking ✦ Design Systems ✦ Information Architecture ✦ Front-end Development ✦ React ✦ TypeScript ✦ Figma ✦ Unity ✦ Visual Design ✦ Adobe Suite ✦ Systematic Design ✦ Storyboarding ✦ Wireframing ✦</span>
        </div>
      </div>

    </div>
  );
}
